import './Radio.scss';
import { ListMixin } from '@components/Mixin/ListMixin/ListMixin.js';
import { Field } from '@components/Component/Field/Field.js';
/**
 * Class `Radio` extends from the `Input` class.
 * It appears as a slider and represents a potential range of values.
 */
export class Radio extends ListMixin(Field) {
    constructor() {
        super(...arguments);
        this.componentName = 'Radio';
        this.inputElements = [];
        this._optionValueKey = 'value';
        this._optionDisplayKey = 'display';
    }
    get optionValueKey() { return this._optionValueKey; }
    set optionValueKey(value) {
        this.optionDataIdKey = value;
        this._propertySet('optionValueKey', value);
        if (this.drawn && this.optionData.length) {
            this.renderOptionData(this.optionData);
        }
    }
    get optionDisplayKey() { return this._optionDisplayKey; }
    set optionDisplayKey(display) {
        this._propertySet('optionDisplayKey', display);
        if (this.drawn && this.optionData.length) {
            this.renderOptionData(this.optionData);
        }
    }
    setupUserChangeEvent() {
        this.registerEvent('click', this.rootElement, this.handleRadioSelection.bind(this));
    }
    handleRadioSelection(event) {
        const selectedRadio = this.rootElement.querySelector('input[type="radio"]:checked');
        if (!(event.target instanceof HTMLInputElement)) {
            return;
        }
        if (selectedRadio) {
            const newValue = selectedRadio.getAttribute('value') || '';
            this.userChange(newValue, this.value);
            console.log('radio value changed', newValue);
        }
    }
    clearSelection() {
        this.inputElements.forEach((input) => {
            input.checked = false;
        });
    }
    renderOptionData(optionData) {
        this.rootElement.innerHTML = '';
        this.inputElements = [];
        if (optionData) {
            optionData.forEach((option) => {
                const input = document.createElement('input');
                input.setAttribute('type', 'radio');
                input.setAttribute('name', this.globalId);
                input.setAttribute('id', option[this.optionValueKey]);
                input.setAttribute('value', option[this.optionValueKey]);
                const label = document.createElement('label');
                label.setAttribute('for', option[this.optionValueKey]);
                if (option.captionKey) {
                    label.innerHTML = this.CaptionManager.getCaption(option.captionKey, option.captionKeyParams);
                }
                else {
                    label.innerHTML = option[this.optionDisplayKey];
                }
                this.inputElements.push(input);
                this.rootElement.appendChild(input);
                this.rootElement.appendChild(label);
            });
        }
    }
    formDesignerPropertiesGet(properties) {
        properties = super.formDesignerPropertiesGet(properties);
        return properties;
    }
}
Radio.VERSION = '$Revision: 112183 $';
